import React from 'react';
import * as classNames from 'classnames';
import Icon from 'antd/lib/icon';
var selfStyles = require('./styles.scss');
var PageDimmer = function (props) {
    var pageDimmerClasses = classNames(selfStyles.dimmer, (_a = {},
        _a[selfStyles.dimmerShowing] = props.isShowing,
        _a));
    return (React.createElement("div", { className: pageDimmerClasses, onClick: props.toggleShowing },
        React.createElement("div", { className: selfStyles.button },
            React.createElement(Icon, { type: 'close', className: selfStyles.icon })),
        React.createElement("div", { className: "ant-modal-mask' " + selfStyles.background })));
    var _a;
};
export default PageDimmer;



//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageDimmer/index.tsx
// module id = 821
// module chunks = 0